import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Organization } from '../models/organization';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  getCompanies(): Observable<Organization[]> {
    return this.http.get<Organization[]>(`${this.configService.getConfiguration().apiHost}/api/organizations`);
  }
}
